// extracted by mini-css-extract-plugin
export var share = "bw_dZ";
export var text = "bw_d0";